import { useQuery } from '@tanstack/react-query';
import { personalSummaryService } from '../api/personal-summary.service';
import { PERSONAL_SUMMARY_KEYS } from './queryKeys';
import type { MyTasksParams } from '../types';

export function useMySummaryTasks(params?: MyTasksParams) {
  return useQuery({
    queryKey: PERSONAL_SUMMARY_KEYS.tasks(params),
    queryFn: ({ signal }) => personalSummaryService.getMyTasks(params, signal),
    staleTime: 120_000,
  });
}
